// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/swipe/index.css
// module id = 212
// module chunks = 32